import React from 'react';
import { format } from 'date-fns';
import defaultAvatar from '../assets/svg/images/default-avatar.jpg';

export default function MessageItem({ message, isOwnMessage, recipientAvatar }) {
  return (
    <div className={`flex mb-4 ${isOwnMessage ? 'justify-end' : 'justify-start'}`}>
      {!isOwnMessage && (
        <img
          src={recipientAvatar}
          alt="Recipient"
          className="w-8 h-8 rounded-full mr-2 self-end"
        />
      )}
      
      <div className={`max-w-xs lg:max-w-md rounded-lg p-3 ${
        isOwnMessage 
          ? 'bg-green-700 text-white rounded-tr-none' 
          : 'bg-gray-700 text-white rounded-tl-none'
      }`}>
        <p>{message.text}</p>
        <div className={`flex items-center mt-1 text-xs ${
          isOwnMessage ? 'text-green-200 justify-end' : 'text-gray-400 justify-start'
        }`}>
          <span>
            {message.timestamp ? format(message.timestamp.toDate(), 'h:mm a') : '...'}
          </span>
          {isOwnMessage && (
            <span className="ml-1">
              {message.status === 'sent' && '✓'}
              {message.status === 'delivered' && '✓✓'}
              {message.status === 'read' && '✓✓✓'}
            </span>
          )}
        </div>
      </div>
    </div>
  );
}